import {ProductDataStore} from "../../stores/productDataStore";
import {AppStateService} from "../../services/appStateService";
import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";

export class HandleService {
    private appStateService: AppStateService;
    private productDataStore: ProductDataStore;
    private uiService: UIService;
    private productDataService: ProductDataService;

    constructor() {
        this.productDataStore = new ProductDataStore();
        this.appStateService = new AppStateService();
        this.productDataService = new ProductDataService();
        this.uiService = new UIService();
    }

    refreshComponentTemplate()
    {
        this.appStateService.setAppSettingTemplateFlag('handles', 'showHandleOptionSelector', this.hasHandleOptions());
        this.appStateService.setAppSettingTemplateFlag('handles', 'showOutsideHandleSelector', this.canHaveDifferentHandlesBothSides());
        this.appStateService.setAppSettingTemplateFlag('handles', 'showHandlePositionSelector', this.productDataService.currentFunctionIsCasementWindow());
        this.uiService.refreshElementsInModule('handles');
    }

    reset()
    {
        const initialInsideHandleId = this.productDataStore.getInitialOptionByName('handleInside').id;
        const initialOutsideHandleId = this.productDataStore.getInitialOptionByName('handleOutside').id;
        const initialHandlePositionId = this.productDataStore.getInitialOptionByName('handlePosition').id;
        const initialHandleOptions = this.productDataStore.getInitialOptionByName('handleOptions');

        this.productDataStore.updateSelectedOption('handleInside', initialInsideHandleId);
        this.productDataStore.updateSelectedOption('handleOutside', initialOutsideHandleId);
        this.productDataStore.updateSelectedOption('handlePosition', initialHandlePositionId);
        this.productDataStore.updateSelectedOption('handleOptions', initialHandleOptions);
    }

    private hasHandleOptions()
    {
        const handleOptions = this.productDataStore
            .getAvailableOptionsByName('handleOptions')
            .filter(handleOption => handleOption.attributes.isHidden === false);

        if (Object.entries(handleOptions).length > 0) {
            return true;
        }
        return false;
    }

    private canHaveDifferentHandlesBothSides()
    {
        return this.productDataStore.getProductInfoAttributeByName('canHaveDifferentHandlesBothSides');
    }

    public toggle(optionName, id)
    {
        if (this.productDataStore.isSelected(optionName, id)) {
            this.remove(optionName, id);
        } else {
            this.select(optionName, id);
        }

        return true;
    }

    public select(optionName, id)
    {
        let selectedAccessories = this.productDataStore.getSelectedOptionByName(optionName);
        let name = optionName.slice(0, -1);

        if (!this.productDataStore.isSelected(optionName, id)) {
            selectedAccessories.push({
                'id': id,
                'type': name,
            });
            this.productDataStore.updateSelectedOption(optionName, selectedAccessories);
        }
        return selectedAccessories;
    }

    public remove(optionName, id)
    {
        let selected = this.productDataStore.getSelectedOptionByName(optionName);

        if (this.productDataStore.isSelected(optionName, id)) {
            selected = selected.filter(function(option) {
                return option.id != id;
            });
            this.productDataStore.updateSelectedOption(optionName, selected);
        }
        return selected;
    }

}
